import React from "react";
import { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import DeleteConfirmModal from "components/common/DeleteConfirmModal";
import Button from "components/common/Button/Button";
import NewTag from "components/common/NewTag";

const CommonSeriesInput = (props) => {
  const {
    setAddNewSeries,
    Preferred = false,
    Series = "",
    UOM = "",
    BDLPerSq = "",
    PricePerUom = "",
    editData = false,
    uomType,
    _id = null,

    addNewSeries,
    saveData,
    deleteData,
    category,
    manufacturer,
    categoryType,
    subType,
    allPrefered,
    priceData,
    setAllPrefered,
    materialSeriesData,
    setAllSeriesData,
    setAdd = false,
    add,
    currency = "$",
    categoryUomType,
  } = props;

  const isNew = priceData?.createdAt && (Date.now() - new Date(priceData.createdAt).getTime()) < 7 * 24 * 60 * 60 * 1000;

  const [isPreferred, setIsPrefered] = useState(Preferred);
  const [series, setSeriesName] = useState(Series);
  const [uom, setUOM] = useState(UOM);
  const [uomValue, setUomValue] = useState(BDLPerSq);
  const [uomPrice, setPricePerUom] = useState(PricePerUom);

  const [edit, setEdit] = useState(editData);
  const [isDelete, setIsDelete] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const deleteModal = () => (
    <DeleteConfirmModal
      isOpen={isDelete}
      toggle={() => setIsDelete(!isDelete)}
      onConfirm={() => {
        deleteData(_id);
        setIsDelete(false);
      }}
    />
  );

  const handleChange = (e, callback) => {
    callback(e.target.value);
  };

  const handleOnClickSave = () => {
    setIsSaving(true);
    saveData(
      { category, manufacturer, categoryType, subType, uomType, isPreferred, series, uom, uomValue, uomPrice, _id },
      {
        onSuccess: () => { setIsSaving(false); setEdit(false); setAdd(false); setAddNewSeries(false); },
        onError: () => setIsSaving(false),
      }
    );
  };

  const handleOnClickCancel = () => {
    if (addNewSeries) {
      setAdd(false);
      setAddNewSeries(false);
    }
    setEdit(false);
    setSeriesName(Series);
    setUOM(UOM);
    setUomValue(BDLPerSq);
    setPricePerUom(PricePerUom);
  };
  const checkPreferred = (list, id) => list.some((data) => data._id === id);

  const showCheckBox =
    allPrefered.length === 0 ||
    (allPrefered.length > 0 && checkPreferred(allPrefered, _id));

  const handleOnChangeCheckBox = () => {
    setIsPrefered(!isPreferred);

    let newMaterialSeries = materialSeriesData.map((doc) => {
      if (_id == doc._id) {
        return { ...doc, isPreferred: !doc.isPreferred };
      }
      return { ...doc, isPreferred: false };
    });

    if (checkPreferred(allPrefered, _id)) {
      setAllPrefered([]);
    } else {
      setAllPrefered([priceData]);
    }
    setAllSeriesData(newMaterialSeries);
    console.log("newMaterialSeries ", newMaterialSeries);
  };

  return (
    <>
      {isDelete && deleteModal()}
      <Row style={{ marginBottom: "15px" }}>
        <Col md="1">
          {showCheckBox && (
            <Form.Group>
              <Form.Check
                name="pType"
                checked={checkPreferred(allPrefered, _id)}
                onChange={handleOnChangeCheckBox}
                style={{ textAlign: "center" }}
              ></Form.Check>
            </Form.Group>
          )}
        </Col>
        <Col md="3">
          <Form.Group style={{ position: "relative" }}>
            <NewTag createdAt={priceData?.createdAt} />
            <Form.Control
              name="pType"
              value={series}
              disabled={!edit}
              onChange={(event) => handleChange(event, setSeriesName)}
              style={{ textAlign: "center", fontSize: "0.8rem" }}
            ></Form.Control>
          </Form.Group>
        </Col>
        <Col md="2">
          <Form.Group>
            <Form.Control
              as="select"
              name="pType"
              value={uom}
              disabled={!edit}
              onChange={(event) => handleChange(event, setUOM)}
              style={{ textAlign: "center", fontSize: "0.8rem" }}
            >
              <option value="">Choose...</option>
              <option value={UOM}>
                {UOM}
              </option>
            </Form.Control>
          </Form.Group>
        </Col>

        {categoryUomType !== "N/A" && category !== "Flat Roofing Primer" && (
          <Col md="2">
            <Form.Group>
              <Form.Control
                type="number"
                value={uomValue}
                disabled={!edit}
                onChange={(event) => handleChange(event, setUomValue)}
                style={{ textAlign: "center", fontSize: "0.8rem" }}
              ></Form.Control>
            </Form.Group>
          </Col>
        )}

        <Col md="2">
          <Form.Group>
            <Form.Control
              type="number"
              value={uomPrice}
              disabled={!edit}
              onChange={(event) => handleChange(event, setPricePerUom)}
              style={{ textAlign: "center", fontSize: "0.8rem" }}
            ></Form.Control>
          </Form.Group>
        </Col>
        {(addNewSeries && !_id) ? (
          <Col md="2">
            <Row>
              <Col md="6">
                <Button
                  variant="success"
                  size="sm"
                  textSize="sm"
                  style={{ width: "60px" }}
                  onClick={handleOnClickSave}
                  isLoading={isSaving}
                  disabled={isSaving}
                >
                  Save
                </Button>
              </Col>
              <Col md="6">
                <Button
                  variant="danger"
                  size="sm"
                  onClick={handleOnClickCancel}
                  disabled={isSaving}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </Col>
        ) : (
          <Col md="2">
            <Row>
              <Col md="6">
                {!edit ? (
                  <Button
                    variant="primary"
                    size="sm"
                    textSize="sm"
                    style={{ width: "60px" }}
                    onClick={() => setEdit(!edit)}
                  >
                    Edit
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    size="sm"
                    textSize="sm"
                    style={{ width: "60px" }}
                    onClick={handleOnClickSave}
                    isLoading={isSaving}
                    disabled={!series || !uomValue || !uomPrice || isSaving}
                  >
                    Save
                  </Button>
                )}
              </Col>
              {!edit && (
                <Col md="6">
                  <Button
                    variant="danger"
                    size="sm"
                    textSize="sm"
                    onClick={() => setIsDelete(true)}
                  >
                    Delete
                  </Button>
                </Col>
              )}

              {edit && (
                <Col md="6">
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={handleOnClickCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        )}
      </Row>
    </>
  );
};

export default CommonSeriesInput;
